module.exports = __webpack_public_path__ + "static/media/sitex-logo.1d0897ac.png";